import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=67470fed&scoped=true&"
import script from "./attendance.vue?vue&type=script&lang=js&"
export * from "./attendance.vue?vue&type=script&lang=js&"
import style0 from "./attendance.vue?vue&type=style&index=0&id=67470fed&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67470fed",
  null
  
)

export default component.exports